import { createLoadable } from './utils/router.utils';

export const Capture = createLoadable(() => import('./capture'));
export const ViewAnswers = createLoadable(() => import('./viewAnswers'));
export const PrintPreview = createLoadable(() => import('./printPreview'));
export const CaptureSubmitted = createLoadable(() => import('./capture/submitted'));
export const NotAvailable = createLoadable(() => import('./capture/notAvailable'));
export const NotFound = createLoadable(() => import('./capture/notFound'));
export const OverQuota = createLoadable(() => import('./capture/overQuota'));
